package space.stanton.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Text
import space.stanton.components.theme.ColorTokens
import space.stanton.config.Globals
import space.stanton.pages.KotlinCodeBlock

@Composable
fun NavScaffold(content: @Composable () -> Unit) {
    Column(
        Modifier
            .fillMaxSize()
            .background(ColorTokens.PageBackground),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Top,
    ) {
        Column(
            Modifier
                .padding(2.cssRem)
                .fillMaxWidth()
                .attrsModifier {
                    style { color(ColorTokens.Body) }
                }
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().padding(2.cssRem),
                verticalAlignment = Alignment.Bottom,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                KotlinCodeBlock(
                    //language=kotlin
                    """
                interface Stanton {
                  suspend fun code(
                    thought: Thought,
                    music: Music, 
                    drink: Coffee, 
                  ): ElegantCode 
                }
            """.trimIndent()
                )
                Column(
                    horizontalAlignment = Alignment.End,
                    modifier = Modifier.padding(leftRight = 3.cssRem)
                ) {
                    Row(Modifier.fontSize(50.pt)) {
                        Text("stanton.space")
                    }
                    Row(
                        Modifier
                            .fontSize(40.pt)
                            .padding(top = 2.cssRem, bottom = 1.cssRem),
                        horizontalArrangement = Arrangement.End
                    ) {
                        NavLink("/", "Home")
                        NavLink("/pages/about-me", "About me")
                        if (Globals.isDebug && false) {
                            NavLink("/pages/labs", "Labs")
                        }
                    }
                }
            }
            Column(
                Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.Start
            ) {
                content()
            }
        }
    }
}
